import {SORT} from  './actionTypes'

export const setSortStateAc = sort => {

  return {
    type: SORT,
    payload: { state: sort },
  }
}